import { readCouponTerms, type CouponTerms } from "@/lib/coupon-readiness"
import { useEffect, useState } from "react"

const CODE_SEPARATOR = "\n"

/** The public terms of each code (read once per page load, null when the record is missing), filled in as the reads come back. */
export function useCouponTerms(merchantId: string | null, codes: readonly string[]): Record<string, CouponTerms | null> {
  const [terms, setTerms] = useState<Record<string, CouponTerms | null>>({})
  const missingKey = codes.filter((code) => !(code in terms)).join(CODE_SEPARATOR)

  useEffect(
    function readMissingCouponTerms() {
      if (!merchantId || !missingKey) return
      let cancelled = false
      for (const code of missingKey.split(CODE_SEPARATOR)) {
        void readCouponTerms(merchantId, code).then((read) => {
          if (!cancelled) setTerms((current) => ({ ...current, [code]: read }))
        })
      }
      return () => {
        cancelled = true
      }
    },
    [merchantId, missingKey],
  )

  return terms
}
